import { useCallback, useEffect, useState } from 'react'
import { PermissionPolicyOption } from '../model/PermissionPolicyOption'
import { usePermissionPolicyRepository } from '../../../../services/adaptors/permissionPolicyRepositoryAdaptor'
import { permissionPolicyService } from '../../../../domain/entity/PermissionPolicyEntity'

export const usePermissionPolicyOptions = () => {
  const [initialized, setInitialized] = useState(false)
  const [allPermissionPolicyOptions, setAllPermissionPolicyOptions] = useState<
    PermissionPolicyOption[]
  >([])
  const [
    attachedByDefaultPermissionPolicies,
    setAttachedByDefaultPermissionPolicies,
  ] = useState<PermissionPolicyOption[]>([])
  const [
    attachablePermissionPolicyOptions,
    setAttachablePermissionPolicyOptions,
  ] = useState<PermissionPolicyOption[]>([])
  const permissionPolicyRepository = usePermissionPolicyRepository()

  const fetchPolicies = useCallback(async () => {
    try {
      const policies = await permissionPolicyRepository.getList()
      const allPolicies: PermissionPolicyOption[] = []
      const attachedByDefaultPolicies: PermissionPolicyOption[] = []
      const attachablePolicies: PermissionPolicyOption[] = []
      policies.forEach(policy => {
        const policyOption = {
          uuid: policy.uuid,
          name: policy.name,
          description: policy.description,
          attachable: policy.attachable,
          attachedByDefault: policy.attachedByDefault,
          scopes: policy.scopes,
        }
        allPolicies.push(policyOption)
        if (permissionPolicyService.isAttachedByDefault(policy)) {
          attachedByDefaultPolicies.push(policyOption)
        }
        if (permissionPolicyService.isAttachable(policy)) {
          attachablePolicies.push(policyOption)
        }
      })
      setAllPermissionPolicyOptions(allPolicies)
      setAttachedByDefaultPermissionPolicies(attachedByDefaultPolicies)
      setAttachablePermissionPolicyOptions(attachablePolicies)
    } finally {
      setInitialized(true)
    }
  }, [permissionPolicyRepository])

  useEffect(() => {
    fetchPolicies()
  }, [fetchPolicies])

  return {
    initialized,
    allPermissionPolicyOptions,
    attachedByDefaultPermissionPolicies,
    attachablePermissionPolicyOptions,
  }
}
